import http from "../helpers/http-common"

class FinanceDataService {

    /**
     * Transactions
     */

    getTransactions(params) {
        return http.post(`/finance/transactions`, params)
    }

    searchTransactions(params) {
        return http.post(`/finance/transactions-search`, params)
    }

    getTransactionsStats(params) {
        return http.post(`/finance/transactions-stats`, params)
    }

    /**
     * Renews Projections
     */

    getProjections(params) {
        return http.post(`/finance/renews-projections`, params)
    }

    getProjectionsStats(params) {
        return http.post(`/finance/renews-projections-stats`, params)
    }

    /**
     * Renews Performance
     */

    getPerformance(params) {
        return http.post(`/finance/renews-performance`, params)
    }

    getPerformancePacks(params) {
        return http.post(`/finance/renews-performance-packs`, params)
    }

    /**
     * Leads Performance
     */

    getPerformanceLeads(params) {
        return http.post(`/finance/leads-performance`, params)
    }

    /**
     * Subscriptions
     */

    getSubscriptions(params) {
        return http.post(`/finance/subscriptions`, params)
    }

    searchSubscriptions(params) {
        return http.post(`/finance/subscriptions-search`, params)
    }

    getSubscriptionsHistory(params) {
        return http.post("/finance/subscriptions-count-history", params)
    }

    getSubscriptionsStats(params) {
        return http.post(`/finance/subscriptions-stats`, params)
    }

    getSubscriptionsPerformance(params) {
        return http.post('/finance/subscriptions-performance', params);
    }

    getSubscriptionsExtendedStats(params) {
        return http.post('/finance/extended-stats', params);
    }

    /**
     * Packs
     */

    getPacks(params) {
        return http.post(`/finance/packs`, params)
    }

    searchPacks(params) {
        return http.post(`/finance/subscriptions-search`, params)
    }

    getPacksHistory(params) {
        return http.post("/finance/packs-count-history", params)
    }

    getPacksStats(params) {
        return http.post(`/finance/packs-stats`, params)
    }

    getPacksPerformance(params) {
        return http.post('/finance/packs-performance', params);
    }

    /**
     * Offers
     */

    getOffersStats(params) {
        return http.post("/finance/offers", params);
    }

    /**
     * SL Groups
     */

    getSlGroupsStats(params) {
        return http.post("/finance/slGroups", params);
    }

    getSlGroupsPools() {
        return http.get("/finance/slGroups-pools");
    }

    getSlGroupsPoolStats(params) {
        return http.post("/finance/slGroups-pool-stats", params);
    }

    /**
     * PM Groups
     */

    getPMGroupsStats(params) {
        return http.post("/finance/pmGroups", params);
    }

    /**
     * Tests Prices
     */

    getTestsPricesStats(params) {
        return http.post("/finance/tests-prices", params);
    }

    getTestsPrices() {
        return http.get('/finance/tests-prices-filters');
    }

    /**
     * VAT
     */

    generateVatExport(params) {
        return http.post('/finance/vat-export', params);
    }
}

export default new FinanceDataService();
